import React from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { selectCmsControlByType } from "../../../../../../redux/slices/cmsSettingsSlice";
import TeamModalHeader from "../../common/TeamModalHeader";

const ConnectedTeamModalHeader = () => {
    const {
        ENUMS: {
            CMS_Control: { P2P_REGISTRATION_CONTENT },
        },
    } = constants;
    const control = useSelector((state) =>
        selectCmsControlByType(P2P_REGISTRATION_CONTENT, state),
    );
    const {
        options: {
            createTeamModal: {
                modalHeading = "Start A New Team",
                additionalText = "",
            },
        },
    } = control;

    const createTeamHeaderProps = {
        title: modalHeading,
        description: additionalText,
    };
    return <TeamModalHeader {...createTeamHeaderProps} />;
};

export default ConnectedTeamModalHeader;
